import {
  Page,
  commonValues
} from './common-modules.js';

export {
  updaqteDeliveryDate
};

const updaqteDeliveryDate = function() {
    const generateOptions = function($el, result) {
        $el.children().not('[value=""]').remove();
        (result || []).forEach(function(item) {
            var $option = $('<option />')
                .attr('value', item.value)
                .text(item.text)
                .prop('selected', item.selected);
            
                $el.append($option);
        });
    };

    $(".js-calibration-delivery-date").change(function() {
        const val = $(this).val(),
            $calibrationCompleteDate = $(".js-calibration-complete-date"),
            // 選択中の値 || 他の項目でバリデーションエラーなど発生したときに戻す用
            selected = $calibrationCompleteDate.val() || $calibrationCompleteDate.data('selected');
        
        // val は「選択してください」選択時には「選択してください」という文字列となる
        if ((val || "").match(/\d{4}-\d{2}-\d{2}/) && urlCalibrationCompleteDateOptions) {
            $.get(urlCalibrationCompleteDateOptions, {delivery_date: val}, function(result) {
                generateOptions($calibrationCompleteDate, result);
                if ($calibrationCompleteDate.find('option[value=' + selected + ']').length) {
                    $calibrationCompleteDate.val(selected);
                }
                $calibrationCompleteDate.trigger('change');
            });
        }
    }).trigger('change');

    $(".js-calibration-complete-date").change(function() {
        const val = $(this).val(),
            $massProductionDeliveryDate = $(".js-mass-production-delivery-date"),
            // 選択中の値 || 他の項目でバリデーションエラーなど発生したときに戻す用
            selected = $massProductionDeliveryDate.val() || $massProductionDeliveryDate.data('selected');

        // val は「選択してください」選択時には「選択してください」という文字列となる
        if ((val || "").match(/\d{4}-\d{2}-\d{2}/) && urlMassProductionDeliveryDateOptions) {
            $.get(urlMassProductionDeliveryDateOptions, {calibration_complete_date: val}, function(result) {
                generateOptions($massProductionDeliveryDate, result);
                if ($massProductionDeliveryDate.find('option[value=' + selected + ']').length) {
                    $massProductionDeliveryDate.val(selected);
                }
            });
        } else {
            // 校正確認（校了）期限未選択時は選択時を消す
            $massProductionDeliveryDate.children().not(':eq(0)').remove();
        }
    });
}
